import React from "react";
import {connect} from "react-redux";
import Home from "../components/Home";

const mapStateToProps = state => ({

});

const mapDispatchToProps = {

};

class HomeContainer extends React.Component {
    render() {
        return (
            <div>
                <Home />
            </div>
            )
        }
    }

export default connect(mapStateToProps, mapDispatchToProps)(HomeContainer);


// WEBPACK FOOTER //
// ./src/container/HomeContainer.js